import type { WordCollection } from "../collection.types";
import { createCollection } from "../logic";

const creaturesWordList = [
  "bat",
  "bear",
  "bee",
  "beetle",
  "butterfly",
  "cat",
  "cow",
  "crab",
  "deer",
  "dog",
  "dolphin",
  "duck",
  "elephant",
  "fish",
  "frog",
  "ghost",
  "goat",
  "horse",
  "mouse",
  "owl",
  "oyster",
  "pig",
  "rabbit",
  "rat",
  "salmon",
  "seal",
  "shark",
  "sheep",
  "shrimp",
  "snake",
  "spider",
  "tiger",
  "tuna",
  "turtle",
  "whale",
  "worm",
];

export const creaturesCollection: WordCollection = createCollection(
  "creatures",
  "Creatures Real & Imagined",
  creaturesWordList,
  { icon: "paw", isWordlistViewable: true },
);
